import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LayoutBand, Grid, Card, Cell, H2, H3, Paragraph, Separator, useContainerWidth } from '@fs/zion-ui'
import questionsAboutGrandmaImage from '../assets/QuestionsAboutGrandma.webp'
import askAboutGrandparentsImage from '../assets/AskAboutGrandparents.webp'

export default function HowToStartSection(): JSX.Element {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <LayoutBand
      maxWidth="xxl"
      marginY={atWidth({ default: 'lg', xl: 'xl' })}
      marginX={atWidth({ default: 'sm', xl: 'xxl' })}
    >
      {/* Main section heading */}
      <H2 size="H3">{t('tree-overview.family-interview.start.heading', 'How to Start the Conversation:')}</H2>
      <Separator size="md" />
      {/* Two-column responsive grid */}
      <Grid gutters={atWidth({ default: 'lg', xl: 'xl' })}>
        {/* Example 1 */}
        <Cell columns={atWidth({ default: 12, xl: 6 })}>
          <EmptyCard backgroundImage={questionsAboutGrandmaImage} />
          <Separator size="sm" />
          <H3 size="H4">{t('tree-overview.family-interview.start.example1-label', 'Example 1:')}</H3>

          <Separator size="sm" />

          <Paragraph size="sm">
            {t(
              'tree-overview.family-interview.start.example1-text',
              "Hey Mom, I'm trying to fill out our family tree. Can I ask you some questions about Grandma?"
            )}
          </Paragraph>
        </Cell>

        {/* Example 2 */}
        <Cell columns={atWidth({ default: 12, xl: 6 })}>
          <EmptyCard backgroundImage={askAboutGrandparentsImage} />
          <Separator size="sm" />

          <H3 size="H4">{t('tree-overview.family-interview.start.example2-label', 'Example 2:')}</H3>

          <Separator size="sm" />

          <Paragraph size="sm">
            {t(
              'tree-overview.family-interview.start.example2-text',
              "Dad, I'd love to know more about your family. Can you tell me about your grandparents?"
            )}
          </Paragraph>
        </Cell>
      </Grid>
    </LayoutBand>
  )
}

function EmptyCard({ backgroundImage }) {
  const atWidth = useContainerWidth()

  return (
    <Card
      backgroundImage={backgroundImage}
      maxWidth={atWidth({ default: undefined, xl: 600 })}
      minHeight={atWidth({ default: 250, lg: 325 })}
    >
      {null}
    </Card>
  )
}

EmptyCard.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
}
